import { AvatarProps } from "@fluentui/react-components";
import ITeamMember from "../../models/ITeamMember";
import teamMemberService from "../../services/TeamMemberService";

export const Avatar = (person: ITeamMember): AvatarProps => {
    const imgUrl = teamMemberService.getTeamMemberPhotoUrl(person.id);

    return {
        color: "colorful",
        name: person.name,
        image: {
            src: imgUrl
        }
    };
};